/**
 * NOS-205: the fee-threshold counter definition, mirrored from the source of
 * truth in `supabase/functions/create-payment-intent/routing.ts` (edge
 * functions and the frontend cannot share modules). Keep the two in lockstep.
 *
 * The free $10k = donations processed through NOS this CALENDAR YEAR (UTC
 * boundary — January Reset). Adopted renewals (NOS-194 migrated recurring
 * giving that NOS records but does not process) never count. This scopes fee
 * math ONLY — contact/dashboard giving displays still show full giving,
 * including adopted renewals.
 */

export const PLATFORM_FEE_THRESHOLD_CENTS = 1_000_000 // $10,000

/** Donation source excluded from the fee counter (see routing.ts). */
export const FEE_COUNTER_EXCLUDED_SOURCE = "adopted"

/** January Reset boundary: Jan 1 00:00:00 UTC of the current year. */
export function currentYearStartUtcIso(now: Date = new Date()): string {
  return new Date(Date.UTC(now.getUTCFullYear(), 0, 1)).toISOString()
}

/**
 * Whether one donation row counts toward the $10k fee threshold — identical
 * definition to the fee math in create-payment-intent.
 */
export function countsTowardFeeThreshold(
  donation: { status: string; source: string | null; created_at: string },
  yearStartIso: string
): boolean {
  return (
    donation.status === "succeeded" &&
    donation.source !== FEE_COUNTER_EXCLUDED_SOURCE &&
    donation.created_at >= yearStartIso
  )
}
